import { render, staticRenderFns } from "./landing-page-privacy-policy.vue?vue&type=template&id=6157efe1&scoped=true&lang=pug"
import script from "./landing-page-privacy-policy.js?vue&type=script&lang=js&external"
export * from "./landing-page-privacy-policy.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-privacy-policy.vue?vue&type=style&index=0&id=6157efe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157efe1",
  null
  
)

export default component.exports